import { styled } from '@mui/material/styles';
import Box from '@material-ui/core/Box';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';


const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 20,
  borderRadius: 10,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    background: 'linear-gradient(to left , #53EEC6, #1EBF9A)',
  },
}));


export default function CustomLinearProgress(props) {
  return (
    <Box className='relative'>
      <span className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 font-bold ${(props.value !== undefined && props.value < 50) ? 'text-gray-400' : 'text-white'}`}>{`${(props.value === undefined) ? 0 : props.value}%`}</span>
      <div><BorderLinearProgress variant="determinate" value={props.value} /></div>
    </Box>
  );
}
